import { useCallback, useRef } from 'react';

/**
 * Returns a stable toggle function for add/remove-by-value multi-select
 * state: if `value` is already in `currentArray` it's removed, otherwise
 * it's appended.
 */
export function useToggleInArray(
  currentArray: string[],
  onChange: (next: string[]) => void
): (value: string) => void {
  const arrayRef = useRef(currentArray);
  arrayRef.current = currentArray;
  const onChangeRef = useRef(onChange);
  onChangeRef.current = onChange;

  return useCallback((value: string) => {
    const arr = arrayRef.current;
    const next = arr.includes(value)
      ? arr.filter(item => item !== value)
      : [...arr, value];
    // Advance the ref to the computed value so a second toggle fired before
    // React rerenders (and refreshes `arrayRef.current` from props) starts
    // from the updated array instead of overwriting the first toggle.
    arrayRef.current = next;
    onChangeRef.current(next);
  }, []);
}
